export function SlackMockup() {
  return (
    <div className="slack-mockup">
      <div className="stamp">Live preview</div>
      <div className="slack-header">
        <div className="slack-header-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span className="slack-channel">finance</span>
      </div>
      <div className="slack-body">
        <div className="slack-msg">
          <div className="slack-avatar user">YN</div>
          <div className="slack-content">
            <span className="slack-name">You</span>
            <span className="slack-time">9:42 AM</span>
            <div className="slack-text">@digis how much runway do we have?</div>
          </div>
        </div>

        <div className="slack-msg">
          <div className="slack-avatar bot">d</div>
          <div className="slack-content">
            <span className="slack-name">digis</span>
            <span className="slack-time">9:42 AM</span>
            <div className="slack-text">
              At current burn, you've got <code>7.4 months</code> of runway. Here's the breakdown:
              <div className="slack-card">
                <div className="slack-card-title">Cash position - May 2026</div>
                <div className="slack-card-row">
                  <span className="label">Cash on hand</span>
                  <span className="val">&euro;184,200</span>
                </div>
                <div className="slack-card-row">
                  <span className="label">Monthly burn (avg)</span>
                  <span className="val">&euro;24,890</span>
                </div>
                <div className="slack-card-row">
                  <span className="label">MRR</span>
                  <span className="val">&euro;8,100</span>
                </div>
                <div className="slack-card-row total">
                  <span className="label">Runway</span>
                  <span className="val">7.4 months</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="slack-msg">
          <div className="slack-avatar user">YN</div>
          <div className="slack-content">
            <span className="slack-name">You</span>
            <span className="slack-time">9:43 AM</span>
            <div className="slack-text">close April and send me the trial balance</div>
          </div>
        </div>

        <div className="slack-msg">
          <div className="slack-avatar bot">d</div>
          <div className="slack-content">
            <span className="slack-name">digis</span>
            <span className="slack-time">9:43 AM</span>
            <div className="slack-text">
              Books closed. <code>412</code> entries auto-matched across Revolut, EBICS + Stripe - TB balanced to the cent. &#10003;
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
